import { formatDateIfValid } from "../formatDateIfValid";

export const formatDateToDateDisplay = (date: Date | string | null) => {
  const formatTemplate = "DD/MM/YYYY";

  return formatDateIfValid(date, { formatTemplate, fallbackValue: " - " });
};
